import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, Sparkles, Clock } from "lucide-react";

export default function FullProgramCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/program/entitlements").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.full_program) return null;

  const statusMeta = {
    available: { label: "Disponible", cls: "text-[#0A6E52] bg-[#E4F3EE]", icon: CheckCircle2 },
    included_pending_generation: { label: "Inclus — personnalisé selon ta progression", cls: "text-obsidian/60 bg-obsidian/[0.04]", icon: Sparkles },
    included_locked: { label: "Inclus — bientôt débloqué", cls: "text-obsidian/60 bg-obsidian/[0.04]", icon: Clock },
    not_entitled: { label: "Non inclus", cls: "text-obsidian/40 bg-obsidian/[0.03]", icon: Clock },
  };

  return (
    <div data-testid="full-program-card" className="mb-8 rounded-[24px] border border-sage/30 bg-white p-6 shadow-premium">
      <div className="flex items-center gap-2">
        <Sparkles className="h-5 w-5 text-sage" />
        <h2 className="text-lg font-medium tracking-tight" data-testid="full-program-title">
          Ta préparation complète est débloquée
        </h2>
      </div>
      <p className="mt-1 text-sm text-obsidian/55" data-testid="full-program-subtitle">
        {data.total_weeks_entitled} semaines · {data.n_entitled} cycles
      </p>

      <div className="mt-5 space-y-2.5">
        {data.cycles.map((c) => {
          const m = statusMeta[c.status] || statusMeta.included_pending_generation;
          const Icon = m.icon;
          return (
            <div
              key={c.cycle}
              data-testid={`full-program-cycle-${c.cycle}`}
              className="flex items-start justify-between gap-3 rounded-2xl border border-obsidian/[0.06] px-4 py-3"
            >
              <div className="min-w-0">
                <div className="text-sm font-medium text-obsidian">
                  Cycle {c.cycle}
                  {c.cycle === data.n_entitled && data.n_entitled > 1 ? " — Affûtage" : ""}
                </div>
                {c.phase_label && c.generated && (
                  <div className="mt-0.5 line-clamp-2 text-xs text-obsidian/50">{c.phase_label}</div>
                )}
              </div>
              <span className={`shrink-0 inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-medium ${m.cls}`}>
                <Icon className="h-3.5 w-3.5" />
                {m.label}
              </span>
            </div>
          );
        })}
      </div>
      <p className="mt-4 text-xs text-obsidian/45">
        Tu as accès à toute ta préparation. MAI construit chaque cycle au bon moment, à partir de ce que tu réalises.
      </p>
    </div>
  );
}
